import { createApi } from "@reduxjs/toolkit/query/react";
import { prepareBaseQuery } from "./baseQueryWithReauth";

const authApi = createApi({
  reducerPath: "auth",
  baseQuery: prepareBaseQuery("/auth/"),
  tagTypes: ["Auth"],
  endpoints: (builder) => ({
    loginUser: builder.mutation({
      query: (credentials) => ({
        url: "rdj-login",
        method: "POST",
        body: credentials,
      }),
    }),
    signupUser: builder.mutation({
      query: (userDetails) => ({
        url: "rdj-signup",
        method: "POST",
        body: userDetails,
      }),
    }),
  }),
});

export const { useLoginUserMutation, useSignupUserMutation } = authApi;

export default authApi;
